import { createFileRoute } from "@tanstack/react-router";
import FaqPage from "@/components/FaqPage";
import { buildHead, breadcrumbLD } from "@/content/seo";
import { faqExpandedLD, boatingBusinessLD } from "@/content/faq-expanded";

const TITLE = "FAQ — Private Yacht Charter Vilamoura | Morningstar";
const DESC =
  "Answers to every question about private yacht charter from Marina de Vilamoura aboard Morningstar — booking, the yacht, what's included, upgrades, logistics and weather.";
const PATH = "/faq";

export const Route = createFileRoute("/faq")({
  component: () => <FaqPage lang="en" />,
  head: () =>
    buildHead({
      lang: "en",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords:
        "vilamoura yacht charter faq, marina de vilamoura boarding, morningstar yacht questions, private boat rental vilamoura faq, benagil cave charter faq",
      altPath: { en: PATH, pt: "/pt/faq" },
      extraScripts: [
        { type: "application/ld+json", children: JSON.stringify(faqExpandedLD("en")) },
        { type: "application/ld+json", children: JSON.stringify(boatingBusinessLD()) },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Home", path: "/" },
              { name: "FAQ", path: PATH },
            ]),
          ),
        },
      ],
    }),
});